/**
 * Initializes the dynamic navigation feature.
 * Adds section IDs to h2 elements in the page content and generates a navigation list for the page.
 */
export default () => {
	// Find the dynamic navigation container
	const dynamicNav = document.querySelector('.js-gsfc-dynamic-nav');

	//Create a new div element to hold the dynamic navigation
	const dynamicNavContainer = document.createElement('div');
	dynamicNavContainer.classList.add('lg:sticky', 'lg:top-9', 'lg:z-10');

	// Find the page content container
	const pageContent = document.querySelector('.js-gsfc-page-content');

	// Check if both dynamicNav and pageContent exist
	if (dynamicNav && pageContent) {
		// Find all h2 elements within the page content
		const h2Elements = pageContent.querySelectorAll('h2');

		// Loop through each h2 element
		h2Elements.forEach((h2, index) => {
			// Generate an ID for each h2 element based on its text content
			const id = h2.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-');
			// Set the ID attribute of the h2 element
			h2.setAttribute('id', `section_${index + 1}_${id}`);
		});

		// Check if there are at least two h2 elements
		if (h2Elements.length >= 2) {
			dynamicNav.classList.add('w-100', 'pr-12', 'lg:w-1/3', 'pb-12');
			pageContent.classList.remove('w-full');
			pageContent.classList.add('lg:w-2/3');

			// Create a header for the navigation menu
			const navHeader = document.createElement('h2');
			navHeader.setAttribute('id', 'onThisPage');
			navHeader.setAttribute('class', 'govuk-heading-m');
			navHeader.textContent = 'Table of Contents';
			// Append the header to the dynamic navigation container
			dynamicNavContainer.appendChild(navHeader);

			// Create an unordered list for the navigation items
			const navList = document.createElement('ul');
			navList.classList.add('list-reset', 'flow-content--sm');

			// Loop through each h2 element
			h2Elements.forEach((h2) => {
				// Create a list item for each h2 element
				const navItem = document.createElement('li');
				navItem.setAttribute('class', 'pb-2');
				// Create an anchor link for each h2 element
				const anchorLink = document.createElement('a');
				anchorLink.setAttribute('href', `#${h2.getAttribute('id')}`);
				anchorLink.setAttribute('class', 'govuk-link govuk-body');
				anchorLink.textContent = h2.textContent;
				// Append the anchor link to the list item
				navItem.appendChild(anchorLink);
				// Append the list item to the unordered list
				navList.appendChild(navItem);
			});

			// Append the unordered list to the dynamic navigation container
			dynamicNavContainer.appendChild(navList);
			dynamicNav.appendChild(dynamicNavContainer);
		}
	}
};
